/* @flow */
import { observable, action } from 'mobx';

import { ApiModel } from 'api/ApiModel';

export default class NavigationSearchStore extends ApiModel {
  @observable navSearchResults: Array<*> = [];

  @observable searchFor: String = '';

  @observable searchIn: String = 'any';

  @observable navResultsCounts: Array<*> = [];

  @observable loadingNavSearchResults: boolean = false;

  updateCounts() {
    this.navResultsCounts = Object.keys(this.navSearchResults).reduce(
      (accObj: Array<*>, key, index) => {
        accObj[key] = this.navSearchResults[key].total;
        return accObj;
      },
      {}
    );
  }

  @action
  async loadNavSearchResults(searchFor: String): Promise<void> {
    this.loadingNavSearchResults = true;

    try {
      const res: ?Array<*> = await this.api.getResource(
        `search?search=${encodeURIComponent(searchFor)}&param=${encodeURIComponent(
          this.searchIn
        )}&all=true`
      );
      this.navSearchResults = res;
      this.updateCounts();
      this.searchFor = searchFor;
    } catch (e) {
      console.log(e, 'catching ERRORS');
    }

    this.loadingNavSearchResults = false;
  }
}
